import {isFeatureEnabled} from 'feature-flags';

import {defaultTo} from 'ramda';

import {featureFlags} from '@dms/feature-flags';
import {percentageToDecimalValue} from '@dms/settings/shared';

import {Nullish} from 'shared/web';

import {FormType} from '../types/ServiceOrderVariant';

// Without the flag the field is left out, so the back-end keeps the stored value.
const getRestrictSaleBelowCostBody = (restrictSaleBelowCost: boolean | Nullish) =>
  isFeatureEnabled(featureFlags.AFS_WAREHOUSE_ACL_SCOPES)
    ? defaultTo(false, restrictSaleBelowCost)
    : undefined;

export function buildGeneralBody(general: FormType['general'] | undefined, isActive: boolean) {
  return {
    ...general,
    isActive,
    serviceCaseTypeId: general?.serviceCaseTypeId ?? '',
    isDefaultForServiceCaseType: !!general?.isDefaultForServiceCaseType,
    serviceOrderTypeId: general?.serviceOrderTypeId ?? '',
    name: general?.name ?? '',
    priceType: general?.priceType ?? '',
    priceTypeRatio: percentageToDecimalValue(general?.priceTypeRatio ?? 100),
    rateType: general?.rateType ?? '',
    rateTypeRatio: percentageToDecimalValue(general?.rateTypeRatio ?? 100),
    minimalMaterialMargin: percentageToDecimalValue(general?.minimalMaterialMargin ?? 0),
    minimalWorkMargin: percentageToDecimalValue(general?.minimalWorkMargin ?? 0),
    suffix: general?.suffix ?? '',
    isUnitPriceWithVat: general?.isUnitPriceWithVat ?? false,
    isChangeableDefaultCustomer: general?.isChangeableDefaultCustomer ?? false,
    isCancelReasonRequired: general?.isCancelReasonRequired ?? false,
    restrictSaleBelowCost: getRestrictSaleBelowCostBody(general?.restrictSaleBelowCost),
  };
}
